import type { PageType } from 'types';
import type { TrackableProduct } from 'types/TrackableProduct';

// WeCanTrack requirement: URL-encode according to RFC 3986
// See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent
export function fixedEncodeURIComponent(str = '') {
  return encodeURIComponent(str).replace(/[!'()*]/g, (c) => {
    return '%' + c.charCodeAt(0).toString(16);
  });
}

export function getCookie(name: string) {
  const isSSR = typeof window === 'undefined';
  const value = isSSR ? '' : `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(';').shift();
}

function init(gaTrackingId: string) {
  if (getCookie('_wctrck')) return;

  window._wct = {
    google_tracking_id: gaTrackingId,
    proxy: 'https://goto-offer.com',
    uid: 'MR9QfV'
  };

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = 'https://goto-offer.com/wct.js?type=session';
  document.head.appendChild(script);
}

function getEventMetadata(pageType: string, product?: TrackableProduct) {
  const metadata = { page_type: pageType } as unknown as {
    pr1br?: string;
    pr1ca?: string;
    pr1id?: string;
    pr1nm?: string;
  };

  if (product) {
    metadata.pr1br = product.brand;
    metadata.pr1ca = product.sub_type === 'sneaker' ? 'ft' : 'cl';
    metadata.pr1id = product.style_code;
    metadata.pr1nm = product.name;
  }

  return metadata;
}

async function fireEvent({
  clickRef,
  clientBrowser,
  clientIp,
  pagePath,
  product,
  url,
  landingPage
}: {
  clickRef: string;
  clientBrowser?: string;
  clientIp: string | null;
  landingPage: PageType;
  pagePath: string;
  product?: TrackableProduct;
  url: string;
}) {
  const payload = {
    _ga: getCookie('_ga'),
    _wctrck: getCookie('_wctrck'),
    affiliate_url: fixedEncodeURIComponent(url),
    clickout_url: fixedEncodeURIComponent(pagePath),
    ip: clientIp,
    metadata: getEventMetadata(landingPage, product),
    redirect_url: fixedEncodeURIComponent(pagePath),
    ua: clientBrowser,
    user_click_reference: clickRef
  };

  return fetch('https://goto-offer.com/api/v1/clickout', {
    body: JSON.stringify(payload),
    headers: {
      'Content-Type': 'application/json',
      'X-API-Key': 'b9fd30f0-9721-4163-8f15-902946f94679'
    },
    method: 'POST'
  });
}

export default { fireEvent, init };
